export const types = {
  GET_HOME_INFO_BEGINS: 'FILTERS/GET_HOME_INFO_BEGINS',
  GET_HOME_INFO_SUCCESS: 'FILTERS/GET_HOME_INFO_SUCCESS',
  GET_HOME_INFO_FAILURE: 'FILTERS/GET_HOME_INFO_FAILURE',
};

export const initialState = {
  homeInfo: [],
};

const HOME = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_HOME_INFO_BEGINS:
      return {
        ...state,
        homeInfoState: 'FETCHING',
        id: action.payload,
      };
    case types.GET_HOME_INFO_SUCCESS:
      return {
        ...state,
        homeInfoState: 'SUCCESS',
        homeInfo: action.payload,
      };
    case types.GET_HOME_INFO_FAILURE:
      return {
        ...state,
        homeInfoState: 'FAILURE',
      };
    default:
      return { ...state };
  }
};

export const actions = {
  getHomeInfoBegins: alias => ({
    type: types.GET_HOME_INFO_BEGINS,
    payload: { alias },
  }),
  getHomeInfoSuccess: data => ({
    type: types.GET_HOME_INFO_SUCCESS,
    payload: data,
  }),
  getHomeInfoFailure: () => ({ type: types.GET_HOME_INFO_FAILURE }),
};

export default HOME;
